import React, { createContext, useContext } from "react";
import useImages from "@/hooks/useImages";

const ImagesContext = createContext({ bySlot: {}, gallery: [], loading: true });

export const ImagesProvider = ({ children }) => {
  const value = useImages();
  return <ImagesContext.Provider value={value}>{children}</ImagesContext.Provider>;
};

export const useLandingImages = () => useContext(ImagesContext);
